module.exports = __webpack_public_path__ + "img/insequa-logo.c41a74d8.png";